import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IAgreementListFilterParams } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterParams';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { agreementListFilterSetPlanNum } from 'AgreementListPackage/AgreementListFiltersModule/actions/agreementListFilterActions';
import { fetchAgreementFindIndex } from 'APIPackage/AgreementListModule/services/agreementListApi';
import { IAgreementIndexPage } from 'APIPackage/AgreementListModule/interfaces/IAgreementIndexPage';

import {
  agreementListFindKnm,
  agreementListGetData,
  agreementListSetData,
  agreementListSetFindData,
} from '../actions/agreementListActions';
import { AgreementListActionsEnum } from '../enums/AgreementListActionsEnum';
import { getRequestFilterData } from '../common/getRequestFilterData';
import { mapRawToData } from '../common/mapRawToData';
import { getAgreementListData, getAgreementListOrder, getAgreementListPage } from '../selectors/agreementListSelectors';

const PAGE_SIZE = 50;

export function* watchAgreementListSaga() {
  yield takeEvery(AgreementListActionsEnum.AGREEMENT_LIST_INIT_PAGE, agreementListInitPageSaga);
  yield takeEvery(AgreementListActionsEnum.AGREEMENT_LIST_GET_DATA, agreementListGetDataSaga);
  yield takeEvery(AgreementListActionsEnum.AGREEMENT_LIST_GET_DATA_NEXT_PAGE, agreementListGetDataNextPageSaga);
  yield takeEvery(AgreementListActionsEnum.AGREEMENT_LIST_FIND_KNM, agreementListFindKnmSaga);
}

function* agreementListInitPageSaga() {
  const planId = window.location.pathname.split('knms/')[1];
  const planNum = Number(planId);

  if (planNum) {
    yield put(agreementListFilterSetPlanNum(planNum));
  } else {
    yield put(agreementListFilterSetPlanNum());
  }
  yield put(agreementListGetData());
}

function* agreementListGetDataSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const order = getAgreementListOrder(state);
    const requestData: IAgreementListFilterParams | null = getRequestFilterData(state);
    const res: IAgreementIndexPage = yield fetchAgreementFindIndex(0, PAGE_SIZE, requestData, order ?? '');

    yield put(agreementListSetData(mapRawToData(res.list), res.page, res.pageCount, res.totalCount, res.rejected));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* agreementListFindKnmSaga(action: ActionType<typeof agreementListFindKnm>) {
  function* funcTry() {
    const { filterParam, size } = action.payload;
    let res: IAgreementIndexPage | undefined;

    res = yield fetchAgreementFindIndex(0, size || PAGE_SIZE, filterParam || null, '');
    if (!res?.list.length) {
      res = yield fetchAgreementFindIndex(0, size || PAGE_SIZE, filterParam || null, '');
    }

    if (res) {
      yield put(agreementListSetFindData(res.list));
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* agreementListGetDataNextPageSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const data = getAgreementListData(state);
    const page = getAgreementListPage(state);
    const order = getAgreementListOrder(state);
    const requestData: IAgreementListFilterParams | null = getRequestFilterData(state);

    const res: IAgreementIndexPage = yield fetchAgreementFindIndex(page + 1, PAGE_SIZE, requestData, order ?? '');

    yield put(
      agreementListSetData([...data, ...mapRawToData(res.list)], res.page, res.pageCount, res.totalCount, res.rejected),
    );
  }

  yield sagaWrapper({
    funcTry,
  });
}
